/* Zabi Hair — Winkelwagen-pagina interacties (AJAX cart). */
(function () {
  var root = document.querySelector('.zabi-cart');
  if (!root) return;

  var sectionId = root.getAttribute('data-section-id');
  var threshold = parseInt(root.getAttribute('data-threshold') || '0', 10);
  var reserveSecs = parseInt(root.getAttribute('data-reserve') || '300', 10);

  function money(cents) {
    if (window.Shopify && window.Shopify.formatMoney && window.cartStrings) {
      // niet altijd beschikbaar; val terug op eigen formatter
    }
    var euros = (cents / 100).toFixed(2).replace('.', ',');
    return '€ ' + euros;
  }

  function setHeaderCount(count) {
    document.querySelectorAll('.zabi-header__cart-count').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('zabi-header__cart-count--hidden', count === 0);
    });
  }

  function render(cart) {
    if (cart.item_count === 0) {
      window.location.reload();
      return;
    }
    // regelitems bijwerken; besparing meerekenen uit opgeslagen unit-compare
    var savings = 0;
    root.querySelectorAll('[data-item]').forEach(function (li) {
      var key = li.getAttribute('data-key');
      var match = cart.items.filter(function (i) { return i.key === key; })[0];
      if (!match) {
        li.remove();
        return;
      }
      var qty = li.querySelector('[data-qty]');
      if (qty) qty.textContent = match.quantity;
      var cur = li.querySelector('.zabi-cart__price-current');
      if (cur) cur.textContent = money(match.final_line_price);
      var unitCompare = parseInt(li.getAttribute('data-unit-compare') || '0', 10);
      if (unitCompare > match.final_price) {
        savings += (unitCompare - match.final_price) * match.quantity;
        var cmp = li.querySelector('.zabi-cart__price-compare');
        if (cmp) cmp.textContent = money(unitCompare * match.quantity);
      }
    });
    savings += (cart.total_discount || 0);

    // totalen
    var sub = root.querySelector('[data-subtotal]');
    if (sub) sub.textContent = money(cart.total_price);
    var tot = root.querySelector('[data-total]');
    if (tot) tot.textContent = money(cart.total_price);
    var saveRow = root.querySelector('[data-save-row]');
    var saveEl = root.querySelector('[data-savings]');
    if (saveRow) {
      if (savings > 0) {
        saveRow.removeAttribute('hidden');
        if (saveEl) saveEl.textContent = '−' + money(savings);
      } else {
        saveRow.setAttribute('hidden', '');
      }
    }

    // aantal-label
    var countEl = root.querySelector('.zabi-cart__count');
    if (countEl) countEl.textContent = cart.item_count + ' ' + (cart.item_count === 1 ? 'artikel' : 'artikelen') + ' · ';

    // progressbar
    var fill = root.querySelector('[data-ship-fill]');
    var text = root.querySelector('[data-ship-text]');
    if (fill && threshold > 0) {
      var pct = Math.min(100, Math.round((cart.total_price / threshold) * 100));
      fill.style.width = pct + '%';
    }
    if (text && threshold > 0) {
      if (cart.total_price >= threshold) {
        text.textContent = 'Gefeliciteerd, je hebt gratis verzending!';
      } else {
        text.textContent = 'Nog ' + money(threshold - cart.total_price) + ' tot gratis verzending';
      }
    }

    setHeaderCount(cart.item_count);
    document.dispatchEvent(new CustomEvent('zabi:cart:updated', { detail: cart }));
  }

  function change(key, quantity) {
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(render);
  }

  root.addEventListener('click', function (e) {
    var stepBtn = e.target.closest('[data-step]');
    if (stepBtn) {
      var li = stepBtn.closest('[data-item]');
      var qtyEl = li.querySelector('[data-qty]');
      var current = parseInt(qtyEl.textContent, 10) || 0;
      var next = current + parseInt(stepBtn.getAttribute('data-step'), 10);
      if (next < 0) next = 0;
      change(li.getAttribute('data-key'), next);
      return;
    }
    var rm = e.target.closest('[data-remove]');
    if (rm) {
      var li2 = rm.closest('[data-item]');
      change(li2.getAttribute('data-key'), 0);
      return;
    }
    var add = e.target.closest('[data-xadd]');
    if (add) {
      add.disabled = true;
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(add.getAttribute('data-variant'), 10), quantity: 1 }] })
      })
        .then(function () { window.location.reload(); });
      return;
    }
    var apply = e.target.closest('[data-discount-apply]');
    if (apply) {
      var input = root.querySelector('[data-discount-input]');
      var code = (input && input.value || '').trim();
      if (code) {
        window.location.href = window.Shopify.routes.root + 'discount/' + encodeURIComponent(code) + '?redirect=/cart';
      }
      return;
    }
  });

  // reserverings-countdown
  var clock = root.querySelector('[data-reserve-clock]');
  if (clock) {
    var remaining = reserveSecs;
    var tick = function () {
      var m = Math.floor(remaining / 60);
      var s = remaining % 60;
      clock.textContent = m + ':' + (s < 10 ? '0' + s : s);
      if (remaining > 0) remaining -= 1;
    };
    tick();
    setInterval(tick, 1000);
  }
})();
